<template>
  <v-card flat class="today-plan-sheet" color="transparent" :class="{'open': open}">
    <v-card-title>
      <v-tooltip attach
                 left
                 max-width="100vw"
                 class="tooltip-coach"
                 :value="open">
        <template v-slot:activator="{ attrs }">
          <v-btn text plain :ripple="false"
                 class="btn-today-plan-opener"
                 v-bind="attrs"
                 @click.prevent>
            오늘의 미션
          </v-btn>
        </template>
        <span class="tooltip-text" id="tooltipTodayPlanOpener">
          오늘의 미션을 눌러<br />
          내게 맞는 추천 미션을 확인해 보세요.
        </span>
      </v-tooltip>
    </v-card-title>
    <v-card-subtitle v-if="open">
      <v-tooltip attach
                 right
                 max-width="100vw"
                 class="tooltip-coach"
                 :value="tooltipActive">
        <template v-slot:activator="{ attrs }">
          <v-btn block rounded depressed color="primary" :ripple="false"
                 class="btn-today-plan-map btn-animation"
                 v-bind="attrs"
                 @click.prevent>
            여행지도
          </v-btn>
        </template>
        <span class="tooltip-text" id="tooltipTodayPlanMap">
          전체 일차 별 미션을 확인하고 <br/>
          미처 하지 못한 미션을 수행할 수 있어요.
        </span>
      </v-tooltip>
    </v-card-subtitle>
    <v-card-text>
      <v-tooltip attach
                 bottom
                 max-width="100vw"
                 class="tooltip-coach"
                 :value="tooltipActive">
        <template v-slot:activator="{ attrs }">
          <div class="solution-list"
               v-bind="attrs">
            <div v-for="(solution, index) in solutions" :key="index"
                 :class="[
                   'solution-list-item',
                   {'solution-list-item--fixed': solution.dailyUnitYn == 'Y'},
                   {'complete': solution.cmpltYn},
                   {'current': solution.dailyUnitYn != 'Y' && currentPlanIndex === index}
                 ]">
              <v-avatar>
                <img :src="getImage(solution.helpfulIcon)"/>
              </v-avatar>
              <div class="unit-info">
                <b class="unit-name">{{solution.unitNm}}</b>
                <span v-if="solution.unitTypeNm !== '' && solution.unitTypeCnt-1 <= 0" class="unit-type">{{solution.unitTypeNm}}</span>
                <span v-else-if="solution.unitTypeNm !== '' && solution.unitTypeCnt-1 > 0" class="unit-type">{{solution.unitTypeNm}} + {{solution.unitTypeCnt-1}}</span>
              </div>
            </div>
          </div>
        </template>
        <span class="tooltip-text" id="tooltipSolutionItem">
          여행지원서 결과에 맞춰 제공되는 <br />
          개인별 추천미션이에요.
        </span>
      </v-tooltip>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CoachMarkBottomSheet',
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tooltipActive: false,
    currentPlanIndex: 0,
    solutions: [
      { unitUseNo:0, unitNm:'마음날씨', helpfulIcon:'ic_mindWeather.svg', dailyUnitYn:'Y', freeYn: 'Y'},
      // { unitUseNo:0, unitNm:'마음노트', helpfulIcon:'ic_mindNote.svg', dailyUnitYn:'Y', freeYn: 'Y'},
      { unitUseNo:0, unitNm:'당신의 빌런은 번아웃?\uD83E\uDD26‍♂️', helpfulIcon:'ic_condition_01.svg',
        dailyUnitYn:'N', freeYn: 'N', lock:'Y', unitTypeNm: "워크시트형",  unitTypeCnt: 4},
      // { unitUseNo:0, unitNm:'휴식이 필요한 순간\uD83E\uDDD8‍♀️',
      //   helpfulIcon:'ic_condition_04.svg',
      //   dailyUnitYn:'N', freeYn: 'N', lock:'Y',unitTypeNm: "몸 알아차리기",  unitTypeCnt: 3},
      { unitUseNo:0, unitNm:'나와 화해하기\uD83E\uDD1D', helpfulIcon:'ic_condition_01.svg',
        dailyUnitYn:'N', freeYn: 'N' , lock:'Y', unitTypeNm:"몰입훈련형", unitTypeCnt: 1},
    ]
  }),
  mounted () {
    setTimeout(function () {
      this.tooltipActive = true
    }.bind(this), 300)
  }
}
</script>
<style lang="scss" scoped>
.tooltip-coach {
  #tooltipTodayPlanOpener {
    left: 50px;
    top: -65px;
    &:after {
      left: -52px;
      top: 13px;
      width: 48px;
      height: 29px;
      background-image: var(--coach-mark-arrow-03);
    }
  }
  #tooltipTodayPlanMap {
    left: -50px;
    top: 60px;
    &:after {
      transform: scale(-1);
      left: 155px;
      top: -20px;
      width: 48px;
      height: 29px;
      background-image: var(--coach-mark-arrow-03);
    }
  }
  #tooltipSolutionItem {
    top: 10px;
    &:after {
      transform: scaley(-1);
      left: -52px;
      top: -15px;
      width: 48px;
      height: 29px;
      background-image: var(--coach-mark-arrow-03);
    }
  }
}
.today-plan-sheet {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: #{var(--system-bar-height)} !important;
  bottom: unset !important;
  width: 100%;
  height: 100%;

  * {
    box-sizing: border-box;
  }

  .v-card__subtitle,
  .v-card__text {
    background-color: #404040 !important;
  }

  .v-card__text {
    flex-grow: 1;
    overflow: hidden;
  }

  .btn-today-plan-map,
  .btn-today-plan-map::before {
    animation: none;
  }

  &.open {
    z-index: 8;
    width: 100%;
  }

  &:not(.open) {
    margin-top: 0 !important;
    top: calc(100% - 86px - 50px) !important;
  }
  .solution-list {
    //position: relative;
    //background-color: #fff;

    .unit-info::before {
      z-index: 0;
    }
    .solution-list-item--fixed {
      mix-blend-mode: multiply;
      opacity: .75;
    }
    .solution-list-item:not(.solution-list-item--fixed) {
      position: relative;
      margin: 0;
      height: 75px;
      padding-bottom: 10px;
      background-color: #fff;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      & + .solution-list-item {
        padding-bottom: 0;
        border-radius: 0 0 10px 10px;
      }
      .unit-info::before {
        z-index: 1;
      }
    }
  }
}

html:not([data-theme="samsungfire"]) {
  .open {
    &.today-plan-sheet.v-card > .v-card__title {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='720px' height='270px'%3E%3Cpath fill-rule='evenodd' fill='%23404040' d='M0.0,269.999 L719.999,269.999 L719.999,149.999 C719.999,122.385 697.614,99.999 669.999,99.999 C669.999,99.999 520.999,99.999 457.999,99.999 C394.999,99.999 378.625,69.554 366.999,49.999 C355.374,30.445 340.933,0.0 297.999,0.0 L49.999,0.0 C22.385,0.0 0.0,22.385 0.0,49.999 L0.0,269.999 Z'/%3E%3C/svg%3E");

      .v-btn.btn-today-plan-opener {
        width: 160px !important;
        height: 40px !important;
        padding: 0 !important;
        margin: 10px 20px 0 10px;
        border-radius: 5rem;
        background-color: #fff !important;
      }
    }
  }
}

[data-theme="samsungfire"] {
  .open {
    &.today-plan-sheet.v-card > .v-card__title {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='360' height='93.119' viewBox='0 0 360 93.119'%3E%3Cg id='그룹_16549' data-name='그룹 16549' transform='translate(15 -417)'%3E%3Cg id='그룹_16548' data-name='그룹 16548' transform='translate(-15 -124)'%3E%3Cg id='그룹_16546' data-name='그룹 16546'%3E%3Cpath id='패스_1084' data-name='패스 1084' d='M26.047,0H196.658A33.721,33.721,0,0,1,220.1,9.891c3.034,3.034,57.256,54.315,57.256,54.315L0,60.69V22.478C0,10.064,11.662,0,26.047,0Z' transform='translate(0 541)' fill='%23404040'/%3E%3Cpath id='패스_1086' data-name='패스 1086' d='M13349.093,12193.134s11.6,12.579,29.315,12.579c-.1,2.331,0,6.293,0,6.293h-29.315Z' transform='translate(-13107.326 -11621.605)' fill='%23404040'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

      .v-btn.btn-today-plan-opener {
        padding: 5px 10px !important;
        margin: 5px 0 -5px 5px;
        border-radius: 5rem;
        background-color: #fff !important;
      }
    }
  }
}
</style>
